module.exports = "<div ui-view ng-show=document></div>";


//////////////////
// WEBPACK FOOTER
// ./web/js/screen/concept/krachtlijnen/conceptKrachtlijnenPage.html
// module id = 1249
// module chunks = 0